import { batch } from '@tmapy/redux';
import { EDIT_TOOLS, INTERACTION, MAP_TOOL, LAYER_IDS } from '@tmapy/config';
import { actionSetInteraction, actionSetLayerFeatures, actionSetLayerStyle, actionSetVectorTileHiddenFeatures, getFeaturesFromLayer, } from '@tmapy/mapcore';
import { actionSetMapTool } from '@tmapy/ui-manager';
import { actionUnhideTileAllFeaturesByLayer } from './actionUnhideTileFeaturesByLayer';
import { DEACTIVATE_TOOL } from '../constants';
const ACTION_INTERACTION_NONE = {
    type: INTERACTION.NONE,
    highlightedFeaturesCount: Infinity,
    originLayerId: null,
    geometryTypeFilter: undefined,
};
const cleanAndUnhideFeatures = (unmanagedLayerId, modifiedFeatures, dispatch) => {
    modifiedFeatures?.forEach((feature) => {
        const tileLayerId = feature.properties?._originLayerId;
        if (tileLayerId) {
            dispatch(actionUnhideTileAllFeaturesByLayer(unmanagedLayerId, tileLayerId));
        }
        dispatch(actionSetLayerFeatures(unmanagedLayerId, []));
    });
};
export const actionDeactivateTools = () => (dispatch, getState) => {
    const state = getState();
    const activeMapTool = state.uiManager.activeMapTool;
    if (!EDIT_TOOLS.includes(activeMapTool)) {
        return; // deactivate edit tools even if no tool is active
    }
    batch('actionDeactivateTools', () => {
        const { layers, interaction } = state.mapCore;
        dispatch(actionSetMapTool(MAP_TOOL.NONE));
        dispatch({
            type: DEACTIVATE_TOOL,
            payload: null,
        });
        if (activeMapTool === MAP_TOOL.DRAW) {
            const originLayerId = interaction.originLayerId;
            if (originLayerId) {
                dispatch(actionSetInteraction(ACTION_INTERACTION_NONE));
                dispatch(actionSetVectorTileHiddenFeatures(originLayerId, []));
                dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_MODIFY, []));
            }
        }
        else {
            const modifiedFeatures = getFeaturesFromLayer(layers, LAYER_IDS.EDIT_TOOLS_MODIFY);
            const highlightFeatures = getFeaturesFromLayer(layers, LAYER_IDS.EDIT_TOOLS_HIGHLIGHT);
            cleanAndUnhideFeatures(LAYER_IDS.EDIT_TOOLS_MODIFY, modifiedFeatures, dispatch);
            cleanAndUnhideFeatures(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, highlightFeatures, dispatch);
            dispatch(actionSetInteraction(ACTION_INTERACTION_NONE));
            dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_SNAP, []));
            dispatch(actionSetLayerStyle(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, 'DEFAULT', 'HIGHLIGHT'));
        }
    });
};
//# sourceMappingURL=deactivateTool.js.map